function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150.002,0h-88.32C51.14,0,42.563,8.577,42.563,19.119v173.445c0,10.542,8.577,19.119,19.119,19.119h88.32 c10.542,0,19.119-8.577,19.119-19.119V19.119C169.121,8.577,160.544,0,150.002,0z M105.842,201.264 c-4.961,0-8.983-4.022-8.983-8.983c0-4.961,4.022-8.983,8.983-8.983c4.961,0,8.983,4.022,8.983,8.983 C114.825,197.242,110.803,201.264,105.842,201.264z M155.868,174.59H55.816V22.519h100.052V174.59z M65.672,70.886V38.319 c0-2.762,2.238-5,5-5h70.34c2.762,0,5,2.238,5,5v32.566c0,2.762-2.238,5-5,5h-70.34C67.91,75.886,65.672,73.647,65.672,70.886z  M144.717,93.554c0,2.762-2.238,5-5,5h-67.75c-2.762,0-5-2.238-5-5c0-2.762,2.238-5,5-5h67.75 C142.479,88.554,144.717,90.792,144.717,93.554z M66.967,115.194c0-2.762,2.238-5,5-5h47.48c2.762,0,5,2.238,5,5 c0,2.762-2.238,5-5,5h-47.48C69.205,120.194,66.967,117.956,66.967,115.194z M124.447,158.476c0,2.762-2.238,5-5,5h-47.48 c-2.762,0-5-2.238-5-5s2.238-5,5-5h47.48C122.209,153.476,124.447,155.714,124.447,158.476z M137.22,136.835c0,2.762-2.238,5-5,5 H71.967c-2.762,0-5-2.238-5-5c0-2.762,2.238-5,5-5h60.253C134.981,131.835,137.22,134.073,137.22,136.835z"
});
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.684 211.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.6b8437ebc64d61032bdcaeba723f235d.svg";
export { ForwardRef as ReactComponent };